import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useGlobalState } from "../../GlobalContext";
import { MagnifyIcon, SettingsIcon } from "../Icons";
import {
  getPageAllowedRoles,
  userHasCorrectRole,
} from "../../js/roles";

function Header() {
  const globalState = useGlobalState();
  const { slot, user, version } = globalState;

  const searchAllowedRoles = getPageAllowedRoles("search");
  const settingsAllowedRoles = getPageAllowedRoles("settings");

  return (
    <nav
      id="header"
      className={classNames(
        "navbar sticky-top d-flex justify-content-between",
        slot ? `${slot.toLowerCase()}-slot` : ""
      )}
    >
      {user && (
        <>
          <ul className="nav">
            {userHasCorrectRole(user, searchAllowedRoles) && (
              <li className="nav-item d-flex align-items-center">
                <a href="/search" className="nav-link">
                  <FontAwesomeIcon
                    className="me-1"
                    icon={MagnifyIcon}
                  />
                  <span>Search</span>
                </a>
              </li>
            )}
            {userHasCorrectRole(user, settingsAllowedRoles) && (
              <li className="nav-item d-flex align-items-center">
                <Link to="/settings" className="nav-link">
                  <FontAwesomeIcon
                    className="me-1"
                    icon={SettingsIcon}
                  />
                  <span>Settings</span>
                </Link>
              </li>
            )}
          </ul>
          <ul className="nav">
            {version && (
              <li className="nav-item d-flex align-items-center">
                <span className="px-3">Version: {version}</span>
              </li>
            )}
            {user.userDetails && (
              <li className="nav-item d-flex align-items-center">
                <span className="px-3">{user.userDetails}</span>
              </li>
            )}
            <li className="nav-item text-nowrap">
              <a href="/.auth/logout" className="nav-link px-3">
                Sign out
              </a>
            </li>
          </ul>
        </>
      )}
    </nav>
  );
}

export default Header;
